import React from 'react';
import Icon from '../../../components/AppIcon';

const RiskExposureMetrics = ({ data }) => {
  const getRiskColor = (level) => {
    switch (level) {
      case 'high':
        return { bg: 'bg-red-500/10', text: 'text-red-500', border: 'border-red-500/20' };
      case 'medium':
        return { bg: 'bg-orange-500/10', text: 'text-orange-500', border: 'border-orange-500/20' };
      case 'low':
        return { bg: 'bg-green-500/10', text: 'text-green-500', border: 'border-green-500/20' };
      default:
        return { bg: 'bg-muted', text: 'text-muted-foreground', border: 'border-border' };
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Risk Exposure Analysis</h3>
          <p className="text-sm text-muted-foreground">Compliance risk categorization</p>
        </div>
        <Icon name="AlertTriangle" size={20} color="var(--color-muted-foreground)" />
      </div>

      {/* Risk Summary Cards */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className={`p-4 rounded-lg border ${getRiskColor('high')?.bg} ${getRiskColor('high')?.border}`}>
          <div className="flex items-center gap-2 mb-2">
            <Icon name="AlertCircle" size={16} color="#ef4444" />
            <span className="text-xs font-medium text-muted-foreground">High Risk</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.totalHighRisk}</p>
        </div>
        <div className={`p-4 rounded-lg border ${getRiskColor('medium')?.bg} ${getRiskColor('medium')?.border}`}>
          <div className="flex items-center gap-2 mb-2">
            <Icon name="AlertTriangle" size={16} color="#f59e0b" />
            <span className="text-xs font-medium text-muted-foreground">Medium Risk</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.totalMediumRisk}</p>
        </div>
        <div className={`p-4 rounded-lg border ${getRiskColor('low')?.bg} ${getRiskColor('low')?.border}`}>
          <div className="flex items-center gap-2 mb-2">
            <Icon name="CheckCircle" size={16} color="#10b981" />
            <span className="text-xs font-medium text-muted-foreground">Low Risk</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.totalLowRisk}</p>
        </div>
      </div>

      {/* Risk by Type Breakdown */}
      <div className="space-y-4">
        {data?.byRegulationType?.map((item, index) => (
          <div key={index} className="p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center justify-between mb-3">
              <span className="font-medium text-foreground">{item?.type}</span>
              <span className="text-sm text-muted-foreground">Total: {item?.total}</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden flex">
                <div
                  className="bg-destructive"
                  style={{ width: `${(item?.high / item?.total) * 100}%` }}
                />
                <div
                  className="bg-orange-500"
                  style={{ width: `${(item?.medium / item?.total) * 100}%` }}
                />
                <div
                  className="bg-success"
                  style={{ width: `${(item?.low / item?.total) * 100}%` }}
                />
              </div>
            </div>
            <div className="flex items-center justify-between mt-2 text-xs">
              <span className="text-destructive">{item?.high} High</span>
              <span className="text-orange-500">{item?.medium} Medium</span>
              <span className="text-success">{item?.low} Low</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RiskExposureMetrics;